import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    models: null,
    groups: null,
    accessories: null,
    options: null,
    packs: null,
    selected: null,
    initialSearch: [],
    dealer: 'none',
    sortMode: 'group',
    popularity: null
  },

  getters: {
    getModels: state => state.models,
    getGroups: state => state.groups,
    getAccessories: state => state.accessories,
    getSelected: state => state.selected,
    getInitialSearch: state => state.initialSearch,
    getDealer: state => state.dealer,
    getSortMode: state => state.sortMode,
    getPopularity: state => state.popularity
  },

  mutations: {
    SET_MODELS (state, p) {
      state.models = p
    },

    SET_GROUPS (state, p) {
      p.push('Varustepaketti')
      state.groups = p
    },

    SET_ACCESSORIES (state, a) {
      // sort accessories by sortmode
      const m = state.sortMode

      /*
      // inject popularity score into accessories if available
      if (typeof state.popularity === 'object' && state.popularity !== null) {
        a.forEach(function (accItem) {
          accItem.popularity = '0'
          state.popularity.forEach(function (popItem) {
            if (popItem.uid === accItem.uid) {
              accItem.popularity = popItem.popularity
            }
          })
        })
      } else {
        console.error('Popularity score not available')
      }
      */

      if (m === 'priceAsc') {
        a = _.sortBy(a, [function (o) { return Number(o.price) }])
      } else if (m === 'priceDesc') {
        a = _.sortBy(a, [function (o) { return Number(o.price) }]).reverse()
      } else if (typeof state.popularity === 'object' && state.popularity !== null && m === 'popularity') {
        a = _.sortBy(a, m).reverse()
      } else {
        a = _.sortBy(a, m)
      }
      state.accessories = a
    },

    SET_OPTIONS (state, p) {
      state.options = p
    },

    SET_PACKS (state, p) {
      state.packs = p
    },

    SET_SELECTED (state, p) {
      state.selected = p
    },

    SET_INITIALSEARCH (state, p) {
      state.initialSearch = p
    },

    SET_DEALER (state, p) {
      state.dealer = p
    },

    SET_SORTMODE (state, p) {
      state.sortMode = p
    },

    SET_POPULARITY (state, p) {
      state.popularity = p
    }
  },

  actions: {
    fetchModels ({ commit }) {
      axios
        .get(process.env.VUE_APP_PROD_API + '/models?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
        .then(response => (commit('SET_MODELS', response.data)))
        .catch(error => { console.log(error) })
    },

    fetchGroups ({ commit }) {
      axios
        .get(process.env.VUE_APP_PROD_API + '/groups?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
        .then(response => (commit('SET_GROUPS', response.data)))
        .catch(error => { console.log(error) })
    },

    /*
    fetchOptions ({ commit }) {
      axios
        .get(process.env.VUE_APP_PROD_API + '/options?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
        .then(response => (commit('SET_OPTIONS', response.data)))
        .catch(error => { console.log(error) })
    },
    */

    fetchPacks ({ commit }) {
      axios
        .get(process.env.VUE_APP_PROD_API + '/packs?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
        .then(response => (commit('SET_ACCESSORIES', response.data)))
        .catch(error => { console.log(error) })
    },

    /*
    fetchAllAccessories ({ commit }) {
      axios
        .get(process.env.VUE_APP_PROD_API + '/accessories?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
        .then(response => (commit('SET_ACCESSORIES', response.data)))
        .then(response => { console.log(response.data) })
        .catch(error => { console.log(error) })
    },

    fetchAccessoriesbyModel ({ commit }, p) {
      axios
        .get(process.env.VUE_APP_PROD_API + '/model/' + p + '/accessories?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
        .then(response => (commit('SET_ACCESSORIES', response.data)))
        .catch(error => { console.log(error) })
    },
    */

    fetchAllAccessories ({ commit }) {
      axios.all([
        axios.get(process.env.VUE_APP_PROD_API + '/accessories?api_token=' + process.env.VUE_APP_PROD_API_TOKEN),
        axios.get(process.env.VUE_APP_PROD_API + '/options?api_token=' + process.env.VUE_APP_PROD_API_TOKEN),
        axios.get(process.env.VUE_APP_PROD_API + '/packs?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
      ])
        .then(responseArr => {
          let merged = responseArr[0].data.concat(responseArr[1].data)
          merged = merged.concat(responseArr[2].data)
          commit('SET_ACCESSORIES', merged)
        })
        .catch(error => { console.log(error) })
    },

    fetchAccessoriesbyModel ({ commit }, p) {
      axios.all([
        axios.get(process.env.VUE_APP_PROD_API + '/model/' + p + '/accessoriesGrouped?api_token=' + process.env.VUE_APP_PROD_API_TOKEN),
        axios.get(process.env.VUE_APP_PROD_API + '/model/' + p + '/optionsGrouped?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
      ])
        .then(responseArr => {
          // console.table(responseArr[0].data)
          // console.table(responseArr[1].data)
          const merged = responseArr[0].data.concat(responseArr[1].data)
          // console.table(merged)
          commit('SET_ACCESSORIES', merged)
        })
        .catch(error => { console.log(error) })
    },

    fetchPacksbyModel ({ commit }, p) {
      axios
        .get(process.env.VUE_APP_PROD_API + '/model/' + p + '/packsGrouped?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
        .then(response => (commit('SET_ACCESSORIES', response.data)))
        .catch(error => { console.log(error) })
    },

    fetchAccessoriesbyGroup ({ commit }, p) {
      axios
        .get(process.env.VUE_APP_PROD_API + '/group/' + p + '/accessories?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
        .then(response => (commit('SET_ACCESSORIES', response.data)))
        .catch(error => { console.log(error) })
    },

    fetchAccessoriesbyModelAndGroup ({ commit }, p) { // p is an array
      axios
        .get(process.env.VUE_APP_PROD_API + '/model/' + p[0] + '/group/' + p[1] + '?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
        .then(response => (commit('SET_ACCESSORIES', response.data)))
        .catch(error => { console.log(error) })
    },

    fetchPopularity ({ commit }) {
      axios
        .get(process.env.VUE_APP_DEMO_PHP_BACKEND + '/popular.php' + '?api_token=' + process.env.VUE_APP_PROD_API_TOKEN)
        .then(response => (commit('SET_POPULARITY', response.data)))
        .catch(error => { console.log(error) })
    },

    updateSelected ({ commit }, p) {
      commit('SET_SELECTED', p)
    },

    updateInitialSearch ({ commit }, p) {
      commit('SET_INITIALSEARCH', p)
    },

    updateAccessories ({ commit }, p) {
      commit('SET_ACCESSORIES', p)
    },

    updateDealer ({ commit }, p) {
      commit('SET_DEALER', p)
    },

    updateSortMode ({ commit, state }, p) {
      commit('SET_SORTMODE', p)
      commit('SET_ACCESSORIES', state.accessories)
    }
  }
})
